import React, { useState, useEffect } from "react"; // Revisa que diga esto
import { Menu, X, Instagram, Mail, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./HomePage.css";
import HomeVideo from "../assets/Home/home_vino.mp4";
import HomeVideo2 from "../assets/Home/Home_Seccion3.mp4";
import image1 from "../assets/Home/Seccion2_1.jpeg";
import image2 from "../assets/Home/Seccion2_2.jpeg";
import image3 from "../assets/Home/Seccion2_3.jpeg";
import image4 from "../assets/Home/Logo_AGNegro.PNG";
import image5 from "../assets/Home/Seccion3.PNG";
import image6 from "../assets/Home/Home.jpeg";
import HomeVideo3 from "../assets/Home/videonuevo.mp4";

import seccion2 from "../assets/Home/Home_Seccion2.jpeg";

const HomePage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const menuOptions = [
    { name: "Aeronave", path: "/aeronave" },
    { name: "Renta de aeronaves", path: "/renta" },
    { name: "Quiénes somos", path: "/nosotros" },
    { name: "Experiencias", path: "/experiencias" },
    { name: "Aviart", path: "/aviart" },
  ];

  const contentOptions = [
    { id: 1, path: image1, caption: "AG Effervescense" },
    { id: 2, path: image2, caption: "Cerveza Mexicana" },
    { id: 3, path: image3, caption: "Vintage 1996" },
  ];

  const contentOptionsBottom = [
    /*{ id: 4, path: image5, caption: "" },*/
    /*{ id: 5, path: image6, caption: "" },*/
  ];

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 105);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="home-container">
      {/* ===== HEADER BAR ===== */}
      <header className="main-header-bar">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`hamburger-btn ${isOpen ? "menu-open" : ""}`}
        >
          {isOpen ? <X size={30} /> : <Menu size={30} />}
        </button>
        <img src={image4} className="header-logo" alt="Logo AG" />
      </header>
      {/* ===== SIDEBAR ===== */}
      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <button onClick={() => setIsOpen(false)} className="sidebar-close-btn">
          <X size={24} />
        </button>
        <nav className="nav-links">
          {menuOptions.map((opt) => (
            <button
              key={opt.name}
              className="nav-item"
              onClick={() => {
                navigate(opt.path);
                setIsOpen(false);
              }}
            >
              {opt.name}
            </button>
          ))}
        </nav>
        <div className="contact-icons">
          <Instagram size={22} style={{ cursor: "pointer" }} />
          <Mail size={22} style={{ cursor: "pointer" }} />
          <Phone size={22} style={{ cursor: "pointer" }} />
        </div>
      </div>
      {/* ===== SECCIÓN HERO ===== */}
      <section className="seccion-hero">
        <div className="contenido-texto-fijo">
          <p>Valle de San Andrés Tuxtla, Veracruz</p>
        </div>
        <img src={seccion2} className="full-width-img1" />
      </section>
      {/* ===== SECCIÓN CASA ANTONIO ===== */}
      <section className="seccion-casa">
        <div className="contenido-texto-fijo6">
          <p>CASA AG</p>
        </div>
        <div className="contenido-texto-fijo7">
          <p style={{ marginBottom: "1cm" }}>
            Casa Antonio González, es más que una historia, unidas por un hilo
            conductor vive el deseo de construir un nuevo legado mexicano,
            creada desde el concepto y sus primeros pasos de la mente de nuestro
            fundador, quien lleva el mismo nombre.
          </p>

          <p>
            Nuestras marcas, Bodega Antonio González, AG Purple Effervescense,
            Reina del Vino, Festival VV y Experiencia VV, son hoy un solo
            universo.
          </p>
        </div>
      </section>
      {/* ===== SECCIÓN 1522 ===== */}
      <section>
        <main className="content-section">
          <div className="video-vertical-wrapper">
            <video autoPlay muted loop playsInline className="video-vertical">
              <source src={HomeVideo3} type="video/mp4" />
            </video>
          </div>
          <div className="contenido-texto-fijo4">
            <p></p>
          </div>
          <div className="contenido-texto-fijo5">
            <p style={{ marginBottom: "1cm" }}>
              En el año 1522, durante los albores del mestizaje y el nacimiento
              de una nueva cultura el capitán de Cortés, Gonzalo de Sandoval,
              llega estas tierras, registrando lo que hoy se convierte en un
              linaje cargado de temple, tierra y carácter; pues en esa misma
              época, en lo profundo de la selva mística de Los Tuxtlas, los
              nativos ya elaboraban un vino ceremonial conocido como "Xoxogo",
              también llamado el "Vino de paz".
            </p>

            <p style={{ marginBottom: "1cm" }}>
              El apellido González encuentra su raíz en un Gonzalo, trazando una
              línea de continuidad que ha atravesado más de cinco siglos, el
              tiempo, caprichoso pero preciso, volvió a pronunciar ese nombre en
              2015 con el primer festival del “Xoxogo”, impulsado por un alcalde
              de la región que lo portaba. No fue coincidencia, sino antesala,
              años después, nuestro fundador, con apenas 25 años, reconoció el
              valor oculto en su tierra, la destreza de sus artesanos, fuerza en
              sus tradiciones y la dignidad de su esfuerzo. Así, lo que parecía
              historia, se reveló como destino y en ese cruce único entre
              linaje, nació Bodega Antonio González como una obra irrepetible.
            </p>
          </div>
        </main>
      </section>
      {/* ===== VIDEO EXTRA ===== */}
      <section className="video-extra-section">
        <video autoPlay muted loop playsInline className="video-extra">
          <source src={HomeVideo2} type="video/mp4" />
        </video>
        <div className="contenido-texto-fijo2">
          <p>Valle de San Andrés Tuxtla, Veracruz</p>
        </div>
        <div className="contenido-texto-fijo3">
          <div
            style={{
              position: "absolute",
              top: "100px",
              left: "40px",
              zIndex: 999,
              color: "white",
              textTransform: "uppercase",
              letterSpacing: "2px",
              fontSize: "0.7rem",
              pointerEvents: "auto",
            }}
          ></div>
          <a
            href="https://reinadelvino.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "white", textDecoration: "none" }}
          >
            Publicidad Oficial de Reina Del Vino México
          </a>
        </div>
      </section>
      <footer>
        <p
          style={{
            fontSize: "10px",
            letterSpacing: "2px",
            color: "#000000",
            margin: 0,
            textAlign: "center",
            paddingTop: "40px" /* Espacio arriba del texto */,
            paddingBottom: "50px" /* Espacio debajo del texto */,
          }}
        >
          Bodega Antonio González - © Todos los derechos reservados.
        </p>
      </footer>

      {/* SCROLLBAR FLOTANTE */}
      <div
        style={{
          position: "fixed",
          right: "4px",
          top: 0,
          width: "4px",
          height: "100vh",
          zIndex: 9999,
          pointerEvents: "none",
        }}
      >
        <div
          id="custom-thumb"
          style={{
            position: "absolute",
            width: "4px",
            borderRadius: "2px",
            backgroundColor: "rgba(0,0,0,0.3)",
            transition: "opacity 0.3s",
          }}
        />
      </div>
    </div>
  );
};

export default HomePage;
